import { IContextualMenuItem, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_LoadingFiles(selectedItemCount: number, waitFor: boolean, waitForContext: string) {
  const languageStrings = React.useContext(LanguageContext);

  const menuItem_LoadingFiles = React.useMemo(() => {
    if (waitFor === true) {
      return {
        key: "loadingFiles",
        text: `${waitForContext} ${selectedItemCount} ${selectedItemCount === 1 ? languageStrings.Item.toLowerCase() : languageStrings.Items.toLowerCase()}`,
        disabled: true,
        onRenderIcon: () => {
          return <Spinner size={SpinnerSize.small} style={{ paddingRight: 5 }} />
        }
      } as IContextualMenuItem;
    }
    return null;
  }, [selectedItemCount, waitFor]);

  return {
    menuItem_LoadingFiles
  }
}